import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';
import { FINDER_START_PATH } from '@rma/finder/agent-finder/public/util-finder-entry-url';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { StaticImageUrlPipe } from '@rma/public/generic/util/environment';
import { CONSULTATION_OFFER_SCOPE, CONSULTATION_OFFER_TICK_KEYS } from './domain/consultation-offer.model';

@Component({
  selector: 'rma-consultation-offer',
  templateUrl: './consultation-offer.component.html',
  imports: [RmaIconComponent, StaticImageUrlPipe, TranslocoDirective],
  host: { class: 'block w-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope(CONSULTATION_OFFER_SCOPE)],
})
export class ConsultationOfferComponent {
  protected readonly scope = CONSULTATION_OFFER_SCOPE;
  protected readonly tickKeys = CONSULTATION_OFFER_TICK_KEYS;
  protected readonly logoPath = 'logos/logo-compact-dark.svg';

  public readonly finderUrl = input(FINDER_START_PATH);

  public readonly dismissed = output<void>();
  public readonly accepted = output<void>();
}
